import { tryCatch } from '@wix/funnel-utils'

import { ambassadorHttpClient } from '../../../../api/httpClient'
import { MAX_QUERY_LENGTH } from './constants'

export async function extractNameSuggestions(query: string): Promise<string[]> {
  const [error, nameSuggestions] = await tryCatch(async () => {
    if (query.length > MAX_QUERY_LENGTH) {
      throw new Error(`query length should be less than ${MAX_QUERY_LENGTH}`)
    }
    const res = await ambassadorHttpClient.post('/_api/wildcat/extract/name-suggestions', { about: query })
    if (!res.data) {
      throw new Error('no response from extract request')
    }
    const { nameSuggestions } = res.data as { nameSuggestions: string[] }
    if (!nameSuggestions) {
      throw new Error('invalid response from extract name suggestions')
    }
    return nameSuggestions
  })
  if (error) {
    return []
  }
  return nameSuggestions
}
